export default {_name:'Text.StatusChip',module:'Field',view:'Element/Text/StatusChip',webOptions:{md:12},mobileOptions:{ms:12}}